import { render } from "./RXResearch.vue?vue&type=template&id=41e55e34&scoped=true"
import script from "./RXResearch.vue?vue&type=script&lang=js"
export * from "./RXResearch.vue?vue&type=script&lang=js"

import "./RXResearch.vue?vue&type=style&index=0&id=41e55e34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e55e34"]])

export default __exports__